import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import fakeData from '../../fakeData';
import Product from '../Product/Product';

const ProductDetail = () => {

    const { productKey } = useParams(); // {const product = fakeData.find(pd => pd.key === productKey);} //Fake Data
    const [product, setProduct] = useState({});
    useEffect(() => {
        fetch('https://ema-jhon-server-site.herokuapp.com/product/' + productKey)
            .then(res => res.json())
            .then(data => {
                setProduct(data);
            })
    }, [productKey])
    return (
        <div>
            <h1>Your Product Details.</h1>
            <Product showAddToCart={false} product={product}></Product>
        </div>
    );
};

export default ProductDetail;